import { render, staticRenderFns } from "./CustomStyleLayout.vue?vue&type=template&id=87915cc2&"
import script from "./CustomStyleLayout.vue?vue&type=script&lang=js&"
export * from "./CustomStyleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports